import React from "react";
import Button from "./Button";

/**
 * IconButton - Small button with icon only (no text)
 * 
 * Use for: Table actions (edit, delete, view), toolbar icons
 * 
 * @example
 * <IconButton 
 *   icon={<PencilIcon />} 
 *   onClick={handleEdit}
 *   variant="primary"
 *   ariaLabel="Edit row"
 * />
 */
const IconButton = ({ icon, ariaLabel, ...props }) => {
  return (
    <Button
      iconOnly={true}
      icon={icon}
      ariaLabel={ariaLabel}
      {...props}
    />
  );
};

export default IconButton;

